export default "__VITE_ASSET__nSmtNW99__"